import React from 'react';
import styled from 'styled-components';
import { observer } from "mobx-react-lite";
import { UndoRedoSlideMenu } from '../editor/UndoRedoSlideMenu';
import { GlobalCombatVariablesEditor } from './GlobalCombatVariablesEditor';
import { PlayerAttacksEditor } from './PlayerAttacksEditor';
import { combatStore } from '../../stores/CombatStore';
const Container = styled.div.withConfig({
  displayName: "CombatConfigurator__Container",
  componentId: "sc-g09ui8-0"
})(["padding:1em;padding-top:3em;"]);
export const CombatConfigurator = observer(() => {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(UndoRedoSlideMenu, null), combatStore.hasConfig && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalCombatVariablesEditor, null), /*#__PURE__*/React.createElement(PlayerAttacksEditor, null)));
});